import { render, staticRenderFns } from "./PrintedLicenses.vue?vue&type=template&id=36dee1b0&"
import script from "./PrintedLicenses.vue?vue&type=script&lang=js&"
export * from "./PrintedLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports